/**
 * Application Constants
 *
 * This file contains all environment-specific configuration and constants.
 * Values are loaded from environment variables at build time.
 *
 * Environment Variables (defined in .env files):
 * - VITE_URL                  - API base URL
 * - VITE_MY_ID_START_SSO_URL  - SSO login URL (MyID)
 * - VITE_ENV                  - Current environment (local, development, qat, staging, production)
 *
 * Environment Files:
 * - .env          - Local development (http://localhost:9090)
 * - .env.dev      - Development server
 * - .env.qa       - QA testing environment
 * - .env.staging  - Staging/UAT environment
 * - .env.production     - Production environment
 *
 * @see vite.config.js - Build configuration for environment handling
 */

// Determine display environment label for UI
let displayEnv = 'LOCAL';

const nodeEnv = (import.meta.env.VITE_ENV || '');

if (nodeEnv === 'development') {
    displayEnv = 'DEVELOPMENT';
}
if (nodeEnv === 'qat') {
    displayEnv = 'QAT';
}
if (nodeEnv === 'staging') {
    displayEnv = 'STAGE';
}
if (nodeEnv === 'production') {
    displayEnv = ''; // No badge shown in production
}

/** Base URL for all API requests */
export const API_BASE = import.meta.env.VITE_URL;

/** SSO login URL - redirects user to MyID for authentication */
export const LOGIN_URL = import.meta.env.VITE_MY_ID_START_SSO_URL;

/** API endpoint keys for reference */
export const ENDPOINTS_KEYS = {
    login: LOGIN_URL,
};

/** Current environment display label (shown in header) */
export const current_env = displayEnv;

/**
 * LocalStorage Keys
 * Standardized keys for storing data in browser localStorage
 */
export const LOCAL_STORAGE_KEYS = {
    main: 'spa-datastage-ui',      // App namespace
    activeUser: 'userId',           // Current user ID
    token: 'access-token',          // JWT auth token
    activeUserRole: 'roles',        // User roles/permissions
};

/**
 * AG-Grid Enterprise License Key
 * Required for AG-Grid enterprise features (filtering, grouping, etc.)
 * Contact admin if expired or invalid
 */
export const LICENSE_KEY =
    'CompanyName=Zones LLC_on_behalf_of_Disney Worldwide Shared SR,LicensedGroup=Disney-CPE,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=2,AssetReference=AG-034073,SupportServicesEnd=31_January_2024_[v2]_MTcwNjY1OTIwMDAwMA==cca4bf4e5146e359f30d98519d653f14';
